import React, { createContext, useContext } from "react"

import Store from "./store"

/* 
CONTEXT / PROVIDER INIT
*/

const ValueAddedServiceStoreContext = createContext<Store | null>(null)

export const StoreProvider: React.FC = (props) => {
    const { children } = props

    return (
        <ValueAddedServiceStoreContext.Provider value={new Store()}>
            {children}
        </ValueAddedServiceStoreContext.Provider>
    )
}

/* 
HOOK DEFINITION
*/

export const useValueAddedServiceStore = () => useContext(ValueAddedServiceStoreContext)
